import { render, staticRenderFns } from "./3pl.vue?vue&type=template&id=3ae8f237&scoped=true"
import script from "./3pl.vue?vue&type=script&lang=js"
export * from "./3pl.vue?vue&type=script&lang=js"
import style0 from "./3pl.vue?vue&type=style&index=0&id=3ae8f237&prod&lang=scss&scoped=true"
import style1 from "./3pl.vue?vue&type=style&index=1&id=3ae8f237&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae8f237",
  null
  
)

export default component.exports